import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { isEmpty, remove } from 'lodash'
import { Style } from './styles'
import { COLOR, IMG } from '../../../themes'
import { KEY_PRESS, MODAL_RESETPASSWORD, CREATE_BOOKING } from '../../../helpers'

export class GuestMultiSelect extends PureComponent {
  static propsType = {
    list: PropTypes.array.isRequired,
    onFocus: PropTypes.func,
    value: PropTypes.string,
    onChange: PropTypes.func,
    selectGuestList: PropTypes.array,
    onSelectGuest: PropTypes.func,
    updateGuestList: PropTypes.func,
    handleSetStateGuestList: PropTypes.func,
    onCloseList: PropTypes.func,
    guest: PropTypes.array,
  }

  state = {
    isFocus: false,
    tagList: [],
    list: [],
    value: '',
    isEmail:true,
    isDuplicateEmail: false
  }

  componentDidMount () {
    const { listEdit, handleSetStateGuestList } = this.props

    handleSetStateGuestList(listEdit)
  }

  componentDidUpdate (prevProps,) {
    const { value, list } = this.props
    const { isEmail, isDuplicateEmail } = this.state

    if (value !== prevProps.value) {
      this.setState({
        value,
        isEmail: true,
        isDuplicateEmail: false,
        ...((!isEmail || isDuplicateEmail) && { isFocus: true }),
      })
    }

    if (list !== prevProps.list) {
      this.setState({
        list,
      })
    }
  }

  _onSelectList = item => {
    const { selectList } = this.state

    this.setState({
      isFocus: false,
      selectList: [
        ...selectList,
        { ...item },
      ],
      value: '',
    })
  }

  _initInputField = () => {
    this.setState({
      isFocus: false,
      value: '',
      isDuplicateEmail: false,
    })
  }
  
  _onSelectGuest = (item) => {
    const { onSelectGuest } = this.props

    onSelectGuest(item)
    this._initInputField()
  }

  _onFocus = () => {
    const { onFocus } = this.props

    this.setState({
      isFocus: true,
    }, () => {
      onFocus()
    })
  }

  _onCloseTag = index => {
    const { tagList } = this.state

    tagList.splice(index, 1)
    this._onFocus()
  }

  _onCloseList = index => {
    const { onFocus, selectGuestList, guest } = this.props

    guest.splice(index, 1)
    selectGuestList.splice(index, 1)

    this.setState({
      isFocus: false,
    }, () => {
      onFocus()
    })
  }

  _checkIsGuestEmail = (value = this.state.value) => {
    const { listEdit, handleSetStateGuestList } = this.props
    const { onSelectGuest } = this.props

    if (!isEmpty(value)) {
      onSelectGuest({"username":value})
      this._initInputField()
    } else {
      handleSetStateGuestList([listEdit])
      this._initInputField()
    }
  }

  _onKeyUp = (event) => {
    if (event.which !== KEY_PRESS.ENTER || event.keyCode !== KEY_PRESS.ENTER) {
      return
    }

    const value = this.state.value.trim()
    const checkEmail=value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
   
    if (!checkEmail) {
      this.setState({isEmail: false, isDuplicateEmail: false, isFocus: false})
    } else if (this._isSelectedEmail(value)) {
      this.setState({isEmail: true, isDuplicateEmail: true, isFocus: false})
    } else {
      this.setState({isEmail: true, isDuplicateEmail: false})
      this._checkIsGuestEmail(value)
    }
  }

  _isSelectedEmail = (email) => {
    const { selectGuestList } = this.props
    return selectGuestList.some(guest => (guest.username || '').trim().toLowerCase() === email.toLowerCase())
  }
  
  render () {
    const {
      onChange = () => { },
      disabled,
      colorTheme
    } = this.props
    const { isFocus, tagList, list, value } = this.state
    const { selectGuestList, searchedKeyword, isSearching } = this.props
    const hasResult = searchedKeyword === value.trim() && list.length > 0
    
    remove(list, item => selectGuestList.filter(ele => ele.username === item.username)[0])

    return (
      <Style colorTheme={colorTheme} style={{cursor: disabled ? 'not-allowed' : 'pointer'}}>
        <div style={{ position: 'relative' }}>
          <div className={'multi-area'.concat(!(this.state.isEmail) || this.state.isDuplicateEmail ? ' error' : '').concat(disabled ? ' disabled': '')}>
            <div className='multi-container'>
              {tagList && tagList.map((item, index) => (
                <div
                  key={`${item.username}_${index}`}
                  className='multi-box'
                >
                  {item.username}
                  <div
                    onClick={() => this._onCloseTag(index)}
                    className='close'>X</div>
                </div>
              ))
              }
              <input
                className='multi-input'
                value={value.replace(/[^a-z0-9@._-\d,\s]+/g, '')}
                onChange={onChange}
                onFocus={this._onFocus}
                disabled={disabled}
                onKeyUp={this._onKeyUp}
                placeholder={CREATE_BOOKING.SEARCH_PARTICIPANTS[this.props.language]}
              />
              <img
                className={isFocus ? 'icon-cancel-dropdown' : 'icon-cancel'}
                src={IMG[isFocus ? 'ic_cancel_text.svg' : 'ic_expand-more.svg']}
                alt='sort'
                onClick={() => this.setState({ isFocus: false, value: '' })}
                style={isFocus ? { width: 16, height: 16, marginLeft: 8 } : { width: 24, height: 24 }}
              />
            </div>
          </div>
          {isFocus && (isSearching || hasResult) && (
            <div className='multi-result'>
              {isSearching && <div className='result-searching'>{CREATE_BOOKING.SEARCHING[this.props.language]}</div>}
              {!isSearching && list.map(item => (
                <div
                  onClick={() => this._onSelectGuest(item)}
                  key={item.username}
                  className='result-list'>
                  <figure>
                    <img
                      className='result-avatar-img'
                      src={item.profileThumbnail
                        ? `data:image/png;base64, ${item.profileThumbnail}`
                        : IMG['user-tie-solid.svg']
                      }
                      alt='user avatar'
                    />
                  </figure>
                  <div className='result-group'>
                    <h1 className='result-title'>{item.name}</h1>
                    <div className='result-description'>{item.username}</div>
                  </div>
                </div>
              ))
              }
            </div>
          )
          }
        </div>
        {!(this.state.isEmail)?<p style={{ color: COLOR.RED_2 }}>{MODAL_RESETPASSWORD.EMAIL_WRONG_FORMAT[this.props.language]}</p>:""}
        {this.state.isDuplicateEmail && <p style={{ color: COLOR.RED_2 }}>{CREATE_BOOKING.GUEST_EMAIL_DUPLICATE[this.props.language]}</p>}

        <div className='multi-select-list'>
          {selectGuestList && selectGuestList.map((item, index) => (
            <div
              key={`${item.username}_${index}`}
              className='select-list'>
              <figure>
                <img
                  className='result-avatar-img'
                  src={!item.profileThumbnail
                    ? IMG['user-tie-solid.svg']
                    : `data:image/png;base64, ${item.profileThumbnail}`
                  }
                  alt='user avatar'
                />
              </figure>
              <div className='result-group'>
                <h1 className='result-title'>{item.name || item.username}</h1>
                {item.name && <div className='result-description'>{item.username}</div>}
              </div>
              <button className='close-button' onClick={() => this._onCloseList(index)} disabled={disabled}>
                <img src={IMG['ic_close-red.svg']} alt='close' />
              </button>
            </div>
          ))
          }
        </div>
      </Style>
    )
  }
}
